import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import GetAppIcon from "@material-ui/icons/GetApp"; // The download icon from Material-UI icons
import { makeStyles } from "@material-ui/core/styles";
import { getDocument } from "../helper/helper";

// Styles for the components
const useStyles = makeStyles((theme) => ({
  list: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    position: "left", // You can adjust the position as needed
    right: 0,
  },
  listItem: {
    cursor: "pointer",
  },
}));

export default function DownloadFilesList({ files, close }) {
  const classes = useStyles();

  // Function to handle file download
  const handleDownload = (url) => {
    // window.open(url, "_blank");
    console.log("more to this??", url);
    getDocument(url);
    close();
  };

  return (
    <List className={classes.list}>
      {files.map((file, index) => (
        <ListItem
          key={file.Key}
          className={classes.listItem}
          onClick={() => handleDownload(file.key)}
        >
          <ListItemIcon>
            <GetAppIcon />
          </ListItemIcon>
          <ListItemText
            primary={`Document ${index + 1}`}
            secondary={decodeURIComponent(
              new URL(file.Location).pathname.split("/").pop()
            )
              .replace(/_/g, " ")
              .replace(/^\d+_/, "")} // the reg expression makes it human readable (example: 1706226515702_Bind_Quote%20Document.pdf)
          />
        </ListItem>
      ))}
    </List>
  );
}
